// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GeoPopup_wrapper__lnqMA","root":"GeoPopup_root__YpcDk","actions":"GeoPopup_actions__2Pbo_","button":"GeoPopup_button__NgkKf"};